import React, { Fragment } from "react";
import { Image, Grid, Divider } from "semantic-ui-react";

const Footer: React.FC = () => {
  return (
    <Fragment>
      <Divider />
      <Grid stackable centered verticalAlign="middle" container columns={3} >
          <Grid.Column>
            <Image src={require("../../assets/bandeiras.png")} />
          </Grid.Column>
          <Grid.Column>
            <Image src={require("../../assets/pgto-online.png")} />
          </Grid.Column>
          <Grid.Column>
            <Image src={require("../../assets/envios.png")} />
          </Grid.Column>
      </Grid>
    </Fragment>
  );
};

export default Footer;
